// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_main_div__835vI {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: baseline;
  overflow: hidden;
  position: relative;
}
.Header_background_Image__hLmyX {
  width: 100%;
  height: 100%;
  position: absolute;
}
.Header_background_Image__hLmyX img {
  position: absolute;
  top: 0;
  z-index: -9999;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.Header_background_mobile_image__Epi1K {
  display: none;
}
.Header_first_section__DNGR8 {
  width: 55%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Header_first_sub_section__R2I7B {
  margin-left: 20%;
  margin-top: 4%;
}
.Header_heading1__1O-IV {
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px; /* 125% */
}
.Header_heading2__RzB5B {
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px;
}
.Header_description__M0B8F {
  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 187.5% */
  margin-bottom: 30px;
}
.Header_letstalk__P0nER {
  width: 177px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 4px;
  border: none;
  background: #fff;
  color: #5b7cfd;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-right: 16px;
}
.Header_learnmore__c3eRC {
  width: 177px;
  height: 56px;
  flex-shrink: 0;
  border: 1px solid white !important;
  border-radius: 4px;
  background: none;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

@media (max-width: 768px) {
  .Header_main_div__835vI {
    width: 100%;
    height: auto;
    display: block;
    position: relative;
  }
  .Header_first_section__DNGR8 {
    width: 100%;
    margin-left: 20px;
    /* margin-top: -35vw; */
    margin-top: 25vw;
    padding-bottom: 55vw;
  }
  .Header_first_sub_section__R2I7B {
    margin-left: 0px;
    width: 100%;
  }
  .Header_heading1__1O-IV {
    font-size: 7.5vw;
  }
  .Header_heading2__RzB5B {
    font-size: 5.4vw;
    line-height: 1.4;
    font-weight: 500;
  }
  .Header_description__M0B8F {
    font-size: 4.2vw;
    width: 73%;
    line-height: 1.7;
    margin-top: 15px;
  }
  .Header_buttons__46H\\+v {
    display: flex;
    flex-direction: row;
    z-index: 99999;
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .Header_letstalk__P0nER {
    width: 10rem;
    height: 2.8rem;
  }
  .Header_learnmore__c3eRC {
    width: 10rem;
    height: 2.8rem;
  }
  .Header_background_Image__hLmyX {
    display: none;
  }
  .Header_background_mobile_image__Epi1K {
    display: block;
    width: 100%;
    z-index: -9999;
    position: absolute;
    top: 0;
    height: 100%;
  }
  .Header_background_mobile_image__Epi1K img {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    object-fit: cover;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/Hero/Header.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".main_div {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: baseline;\n  overflow: hidden;\n  position: relative;\n}\n.background_Image {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n.background_Image img {\n  position: absolute;\n  top: 0;\n  z-index: -9999;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.background_mobile_image {\n  display: none;\n}\n.first_section {\n  width: 55%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.first_sub_section {\n  margin-left: 20%;\n  margin-top: 4%;\n}\n.heading1 {\n  font-family: Roboto;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 50px; /* 125% */\n}\n.heading2 {\n  font-family: Roboto;\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 50px;\n}\n.description {\n  color: #fff;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 30px; /* 187.5% */\n  margin-bottom: 30px;\n}\n.letstalk {\n  width: 177px;\n  height: 56px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: none;\n  background: #fff;\n  color: #5b7cfd;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-right: 16px;\n}\n.learnmore {\n  width: 177px;\n  height: 56px;\n  flex-shrink: 0;\n  border: 1px solid white !important;\n  border-radius: 4px;\n  background: none;\n  color: #fff;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n@media (max-width: 768px) {\n  .main_div {\n    width: 100%;\n    height: auto;\n    display: block;\n    position: relative;\n  }\n  .first_section {\n    width: 100%;\n    margin-left: 20px;\n    /* margin-top: -35vw; */\n    margin-top: 25vw;\n    padding-bottom: 55vw;\n  }\n  .first_sub_section {\n    margin-left: 0px;\n    width: 100%;\n  }\n  .heading1 {\n    font-size: 7.5vw;\n  }\n  .heading2 {\n    font-size: 5.4vw;\n    line-height: 1.4;\n    font-weight: 500;\n  }\n  .description {\n    font-size: 4.2vw;\n    width: 73%;\n    line-height: 1.7;\n    margin-top: 15px;\n  }\n  .buttons {\n    display: flex;\n    flex-direction: row;\n    z-index: 99999;\n    position: absolute;\n    bottom: 5%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  .letstalk {\n    width: 10rem;\n    height: 2.8rem;\n  }\n  .learnmore {\n    width: 10rem;\n    height: 2.8rem;\n  }\n  .background_Image {\n    display: none;\n  }\n  .background_mobile_image {\n    display: block;\n    width: 100%;\n    z-index: -9999;\n    position: absolute;\n    top: 0;\n    height: 100%;\n  }\n  .background_mobile_image img {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_div": `Header_main_div__835vI`,
	"background_Image": `Header_background_Image__hLmyX`,
	"background_mobile_image": `Header_background_mobile_image__Epi1K`,
	"first_section": `Header_first_section__DNGR8`,
	"first_sub_section": `Header_first_sub_section__R2I7B`,
	"heading1": `Header_heading1__1O-IV`,
	"heading2": `Header_heading2__RzB5B`,
	"description": `Header_description__M0B8F`,
	"letstalk": `Header_letstalk__P0nER`,
	"learnmore": `Header_learnmore__c3eRC`,
	"buttons": `Header_buttons__46H+v`
};
export default ___CSS_LOADER_EXPORT___;
